import cx from "classnames";
import Button from "components/Button/Button";
import "./Pagination.css";

export type PaginationProps = {
  page: number;
  pageCount: number;
  onPageChange: (page: number) => void;
  topMargin?: boolean;
};

function getPageNumbers(current, total) {
  const pages: (number | "...")[] = [];
  const delta = 2;
  const left = Math.max(2, current - delta);
  const right = Math.min(total - 1, current + delta);

  pages.push(1);
  if (left > 2) pages.push("...");
  for (let i = left; i <= right; i++) pages.push(i);
  if (right < total - 1) pages.push("...");
  if (total > 1) pages.push(total);

  return pages;
}

export default function Pagination({ page, pageCount, topMargin = true, onPageChange }: PaginationProps) {
  if (pageCount <= 1) return null;

  const pages = getPageNumbers(page, pageCount);

  return (
    <div className={cx("pagination", { "mt-25": topMargin })}>
      <div className="pagination-buttons">
        <Button variant="pagination" onClick={() => onPageChange(page - 1)} disabled={page <= 1}>
          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
            <path d="M7 13L1 7L7 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </Button>
        {pages.map((p, index) => (
          <button
            key={index}
            className={cx("pagination-btn", { active: p === page })}
            onClick={() => typeof p === "number" && onPageChange(p)}
            disabled={p === "..."}
          >
            {p}
          </button>
        ))}
        <Button variant="pagination" onClick={() => onPageChange(page + 1)} disabled={page >= pageCount}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </Button>
      </div>
    </div>
  );
}
